import {connect} from "react-redux";

import DriverStates from "./DriverStates";
import {getFilteredDrivers} from "../../selectors/driver_states";
import {withRouter} from "react-router-dom";
import {getComputedDockListShipping} from "../../selectors/dock";

const mapStateToProps = (state, ownProps) => {

  return {
    drivers: getFilteredDrivers(state, ownProps),
    docks: getComputedDockListShipping(state),
  };
};

const mapDispatchToProps = dispatch => {
  // WIP HERE
  return {
  };
};

export const DriverStatesLinked = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverStates));


export default DriverStatesLinked;
